import * as React from 'react'
import { ReactElement } from 'react'
import ReportForm from './ReportForm'
import { DocumentGenerationType } from '../../../../hooks/document/useDocumentGenerationHandler'
import { ReportFormType } from '../../../../pages/Finance/Reports'

export default function TurnoverDashboardReportForm(props: ReportFormType): ReactElement {
    return (
        <ReportForm<any>
            title="Managementrapportage Omzet"
            generationType={DocumentGenerationType.TurnoverDashboardXls}
            initialValues={{}}
            {...props}
        ></ReportForm>
    )
}
